import { render, staticRenderFns } from "./DiagramDetail.vue?vue&type=template&id=147fa592&"
import script from "./DiagramDetail.vue?vue&type=script&lang=js&"
export * from "./DiagramDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports